module.exports = __webpack_public_path__ + "dam/illu-maintenance.svg";